/*
* Reusable GWP Engine — Jaqua / Palo Alto Theme
*/

(function () {
  console.log('✅ GWP Engine Loaded');

  let gwpInserted = false;
  let lastGWPUpdateTime = 0;
  const GWP_UPDATE_INTERVAL = 2000;

  // ================================
  // 🔧 CONFIG (ONLY EDIT THIS SECTION)
  // ================================

  const CONFIG = {
    promoType: "product", // "product" | "threshold" | "none"
    gwpMode: "choice",    // "single" | "choice"

    // qualifying products (for product-based promos)
    qualifyingVariantIds: [
      144017653783, // full-size signature EDP
      372110000151  // full-size rose EDP
    ],

    // threshold (only used if promoType = "threshold")
    threshold: 85,

    // gift variants
    gwpVariants: {
      signature: 41473805352983, // mini signature EDP
      rose: 41473815019543       // mini rose EDP
    },

    // UI text
    text: {
      teaser: "add a full-size eau de parfum to receive a complimentary mini.",
      qualified: "enjoy a complimentary mini eau de parfum with your purchase. please select your scent:",
      inCart: "your complimentary mini eau de parfum is in your cart!",
      restricted: "gift cannot be combined with subscriptions or other offers."
    }
  };

  // ================================
  // 🔍 CORE LOGIC
  // ================================

  function updateGWPMessage(retries = 10) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        // 🔎 detect qualifying condition
        let qualifies = false;

        if (CONFIG.promoType === "product") {
          qualifies = cart.items.some(item =>
            CONFIG.qualifyingVariantIds.includes(item.variant_id)
          );
        }

        if (CONFIG.promoType === "threshold") {
          const gwpIds = Object.values(CONFIG.gwpVariants);

          const cartTotal = cart.items
            .filter(item => !gwpIds.includes(item.variant_id))
            .reduce((sum, item) => sum + item.final_line_price, 0) / 100;

          qualifies = cartTotal >= CONFIG.threshold;
        }

        const hasGWP = cart.items.some(item =>
          Object.values(CONFIG.gwpVariants).includes(item.variant_id)
        );

        const hasSubscription = cart.items.some(item =>
          item.properties &&
          Object.keys(item.properties).some(key =>
            key.toLowerCase().includes('subscription')
          )
        );

        let messageBox = document.querySelector('.gwp-message');

        // inject container
        if (!messageBox && !gwpInserted) {
          const shippingMessage = document.querySelector('[data-cart-message]');
          const drawerBody = document.querySelector('.cart-drawer__body');
          const anchor = shippingMessage || drawerBody;

          if (!anchor) {
            if (retries > 0) {
              setTimeout(() => updateGWPMessage(retries - 1), 300);
            }
            return;
          }

          messageBox = document.createElement('div');
          messageBox.className = 'gwp-message cart__message';
          messageBox.style.textAlign = 'center';

          anchor.insertAdjacentElement('afterend', messageBox);
          gwpInserted = true;
        }

        if (!messageBox) return;

        // ================================
        // 🎁 DISPLAY LOGIC
        // ================================

        if (qualifies && !hasSubscription) {

          if (!hasGWP) {

            // 🎯 SINGLE GIFT
            if (CONFIG.gwpMode === "single") {

              const variantId = Object.values(CONFIG.gwpVariants)[0];

              messageBox.innerHTML = `
                ${CONFIG.text.qualified}
                <br>
                <button class="gwp-add-button"
                  style="margin-top:6px;background:#95A929;color:#fff;border:none;padding:8px 12px;cursor:pointer;font-size:14px;">
                  add free gift
                </button>
                <div style="font-size:12px;margin-top:4px;">
                  ${CONFIG.text.restricted}
                </div>
              `;

              messageBox.querySelector('.gwp-add-button')
                ?.addEventListener('click', () => maybeAddGWP(variantId));

            }

            // 🎯 CHOICE MODE (your current promo)
            if (CONFIG.gwpMode === "choice") {

              messageBox.innerHTML = `
                ${CONFIG.text.qualified}
                <div style="margin-top:10px;">
                  <button class="gwp-add-signature"
                    style="margin:0 6px;background:#95A929;color:#fff;border:none;padding:8px 12px;cursor:pointer;font-size:14px;">
                    signature
                  </button>
                  <button class="gwp-add-rose"
                    style="margin:0 6px;background:#ac7a6b;color:#fff;border:none;padding:8px 12px;cursor:pointer;font-size:14px;">
                    *rose
                  </button>
                </div>
                <div style="font-size:12px;margin-top:6px;">
                  limit 1 per order. ${CONFIG.text.restricted}
                </div>
              `;

              messageBox.querySelector('.gwp-add-signature')
                ?.addEventListener('click', () => maybeAddGWP(CONFIG.gwpVariants.signature));

              messageBox.querySelector('.gwp-add-rose')
                ?.addEventListener('click', () => maybeAddGWP(CONFIG.gwpVariants.rose));
            }

          } else {
            messageBox.textContent = CONFIG.text.inCart;
          }

        } else if (!qualifies && !hasSubscription) {
          messageBox.innerHTML = `
            ${CONFIG.text.teaser}
            <div style="font-size:12px;margin-top:4px;">
              ${CONFIG.text.restricted}
            </div>
          `;
        } else {
          messageBox.classList.add('is-hidden');
          return;
        }

        messageBox.classList.remove('is-hidden');
      });
  }

  // ================================
  // 🛒 ADD GWP
  // ================================

  function maybeAddGWP(variantId) {
  console.log('🛒 Attempting to add variant:', variantId);

  const btns = document.querySelectorAll('.gwp-add-button, .gwp-add-signature, .gwp-add-rose');
  btns.forEach(btn => {
    btn.disabled = true;
    btn.textContent = 'adding...';
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(async (res) => {
      const data = await res.json();

      if (!res.ok) {
        console.error('❌ Shopify add error:', data);

        btns.forEach(btn => {
          btn.disabled = false;
          btn.textContent = 'add free gift';
        });

        return;
      }

      console.log('✅ Added to cart:', data);

      // FORCE CART REFRESH (important for Palo Alto)
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(updateGWPMessage, 300);
    })
    .catch(err => {
      console.error('❌ Network error:', err);

      btns.forEach(btn => {
        btn.disabled = false;
        btn.textContent = 'add free gift';
      });
    });
}

  window.updateGWPMessage = updateGWPMessage;

  document.addEventListener('DOMContentLoaded', () => {
    updateGWPMessage();

    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      return originalFetch.apply(this, args).then(res => {
        const now = Date.now();
        if (args[0].includes('/cart') && now - lastGWPUpdateTime > GWP_UPDATE_INTERVAL) {
          lastGWPUpdateTime = now;
          setTimeout(updateGWPMessage, 120);
        }
        return res;
      });
    };

    document.body.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-drawer-toggle]')) {
        setTimeout(updateGWPMessage, 400);
      }
    });
  });

})();